import update from 'immutability-helper';
import { createReducer } from '../modules/helpers';
import { ActionTypes } from '../constants/index';

const initState = {
  profile: {
    name: '',
    email: '',
    avatarInitials: '',
    address1: '',
    address2: '',
    city: '',
    zipcode: '',
    state: '',
    country: '',
    phonePrefix: '',
    phone: '',
  },
  status: 'init', // init -> loading (network) -> loaded -> updating (network) -> loaded
};

export const profileReducer = createReducer(initState, {
  [ActionTypes.PROFILE_GET_REQUEST](state) {
    return update(state, {
      profile: { $set: initState.profile },
      status: { $set: 'loading' },
    });
  },
  [ActionTypes.PROFILE_GET_SUCCESS](state, { payload }) {
    return update(state, {
      profile: { $set: payload },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.PROFILE_GET_FAILURE](state) {
    return update(state, {
      status: { $set: 'error' },
    });
  },
  [ActionTypes.PROFILE_UPDATE_REQUEST](state) {
    return update(state, {
      status: { $set: 'updating' },
    });
  },
  [ActionTypes.PROFILE_UPDATE_SUCCESS](state, { payload }) {
    return update(state, {
      profile: { $set: payload },
      status: { $set: 'loaded' },
    });
  },
  [ActionTypes.PROFILE_UPDATE_FAILURE](state) {
    return update(state, {
      status: { $set: 'error' },
    });
  },
  // [ActionTypes.PROFILE_EDIT_MODE](state) {
  //   return update(state, {
  //     status: { $set: 'edit' },
  //   });
  // },
  // [ActionTypes.PROFILE_PREVIEW_MODE](state) {
  //   return update(state, {
  //     status: { $set: 'preview' },
  //   });
  // },
});



// WEBPACK FOOTER //
// ./scripts/reducers/profile.js